import { useEffect, useState } from 'react';
import moment from 'moment';
import { getPreciseDiff, type PreciseDiff } from './getPreciseDiff';

type CountDown = PreciseDiff & {
  isExpired: boolean;
};

const useCountDown = ({
  targetDate,
  shouldCountFromTargetDate = false,
  stopDatetime,
}: {
  targetDate: string;
  shouldCountFromTargetDate?: boolean;
  stopDatetime?: string;
}) => {
  const countDownDate = moment(targetDate);

  const [countDown, setCountDown] = useState<CountDown | null>(null);

  const getTime = () => {
    const endDate = stopDatetime ? moment(stopDatetime) : moment();

    const preciseDiff = shouldCountFromTargetDate
      ? getPreciseDiff(endDate, countDownDate)
      : getPreciseDiff(countDownDate, endDate);

    setCountDown({
      ...preciseDiff,
      years: 0,
      months: preciseDiff.months + preciseDiff.years * 12,
      isExpired: !preciseDiff.firstDateWasLater,
    });
  };

  useEffect(() => {
    getTime();

    const interval = setInterval(getTime, 1000);

    return () => clearInterval(interval);
    // Suppressed warnings because we only need to call useEffect callback only after updating targetDate.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [targetDate]);

  return countDown;
};

export default useCountDown;
